import { request, getHeaders } from './http';
import { cachedRead, clearReadCache, invalidateReadCache } from './readCache';

export async function login(email, password) {
  const result = await request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  clearReadCache();
  return result;
}

export async function forgotPassword(email) {
    return request('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export async function validateResetToken(token) {
    return request('/auth/validate-reset-token', {
      method: 'POST',
      body: JSON.stringify({ token }),
    });
  }

export async function resetPassword(token, newPassword) {
    return request('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, newPassword }),
    });
  }

export async function impersonateUser(targetUserId) {
  const result = await request('/auth/impersonate', {
    method: 'POST',
    body: JSON.stringify({ targetUserId }),
  });
  clearReadCache();
  return result;
}

export async function stopImpersonation() {
  const result = await request('/auth/stop-impersonation', {
    method: 'POST',
  });
  clearReadCache();
  return result;
}

export async function getProfile(options = {}) {
  if (options.fresh) invalidateReadCache('profile');
  return cachedRead('profile', () => request('/auth/profile'));
}

export async function getPermissions() {
    const isDev = process.env.NODE_ENV !== 'production';
    const url = `/auth/permissions?t=${Date.now()}${isDev ? '&debug=1' : ''}`;
    return request(url);
  }

export async function refreshPermissions() {
    const isDev = process.env.NODE_ENV !== 'production';
    const url = `/auth/permissions?t=${Date.now()}${isDev ? '&debug=1' : ''}`;
    return request(url, {
      method: 'GET',
      headers: {
        ...getHeaders(),
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
  }

export async function updateProfile(profileData) {
  const result = await request('/auth/profile', {
    method: 'PUT',
    body: JSON.stringify(profileData),
  });
  invalidateReadCache('profile');
  return result;
}

export async function changePassword(currentPassword, newPassword) {
  const result = await request('/auth/change-password', {
    method: 'PUT',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  invalidateReadCache('profile');
  return result;
}

export async function forceChangePassword(newPassword) {
  const result = await request('/auth/force-change-password', {
    method: 'PUT',
    body: JSON.stringify({ newPassword }),
  });
  invalidateReadCache('profile');
  return result;
}

export async function updatePreferences(preferences) {
  const result = await request('/auth/preferences', {
    method: 'PUT',
    body: JSON.stringify(preferences),
  });
  invalidateReadCache('profile');
  return result;
}

export async function getEmailAlertTypes() {
    return request('/users/email-alert-types');
  }

export async function getEmailPreferences() {
    return request('/auth/email-preferences');
  }

export async function updateEmailPreferences(preferences) {
    return request('/auth/email-preferences', {
      method: 'PUT',
      body: JSON.stringify({ preferences }),
    });
  }

export async function logout() {
  clearReadCache();
  return request('/auth/logout', {
    method: 'POST',
  });
}

export const authApi = {
  login,
  forgotPassword,
  validateResetToken,
  resetPassword,
  impersonateUser,
  stopImpersonation,
  getProfile,
  getPermissions,
  refreshPermissions,
  updateProfile,
  changePassword,
  forceChangePassword,
  updatePreferences,
  getEmailAlertTypes,
  getEmailPreferences,
  updateEmailPreferences,
  logout,
};

